import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTaskFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20 32C26.6274 32 32 26.6274 32 20C32 17.7942 31.4048 15.7273 30.3663 13.9513L19.8854 24.4323L19.1789 25.1387L18.4718 24.4329L14.0935 20.0627L15.5065 18.6472L19.1776 22.3116L29.1974 12.2919C26.9961 9.66808 23.6928 8 20 8C13.3726 8 8 13.3726 8 20C8 26.6274 13.3726 32 20 32Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgTaskFilled);
export default ForwardRef;
